import type { MouseEventHandler } from 'react';

import logo from '@/assets/images/gxLogo.svg';

type GoLogoProps = {
  size?: number;
  open?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
};

const GoLogo = ({ size = 64, open = true, onClick }: GoLogoProps) => {
  let cursor: 'e-resize' | 'w-resize' | undefined;
  if (onClick) cursor = open ? 'w-resize' : 'e-resize';

  return (
    <button
      aria-label={onClick ? 'Toggle navigation' : undefined}
      className='flex items-center justify-start'
      disabled={!onClick}
      style={{ cursor }}
      type='button'
      onClick={onClick}
    >
      <img
        alt='GX'
        height={size}
        src={logo}
      />
      {open && (
        <span
          className='ml-2 select-none font-medium leading-none text-primary animate-in fade-in slide-in-from-left-1 duration-300'
          style={{ fontSize: size }}
        >
          Go
        </span>
      )}
    </button>
  );
};

export default GoLogo;
